<template>
  <section class="home-news" aria-labelledby="news-title">
    <div class="home-news__container">
      <header class="home-news__heading">
        <div>
          <p class="home-news__eyebrow">NEWS</p>
          <h2 id="news-title">新闻资讯</h2>
        </div>
<!--        <router-link class="home-news__more" to="/news">查看全部</router-link>-->
      </header>

      <div v-if="loading" class="news-grid news-grid--loading" aria-label="新闻加载中">
        <div v-for="item in 4" :key="item" class="news-skeleton">
          <div class="news-skeleton__image"></div>
          <div class="news-skeleton__line news-skeleton__line--title"></div>
          <div class="news-skeleton__line"></div>
        </div>
      </div>

      <div v-else-if="dataList.length" class="news-grid">
        <router-link
          v-for="item in dataList"
          :key="item.noticeId"
          class="news-card"
          :to="{ path: '/infolistItem', query: { id: item.noticeId, back: '#/index' } }"
        >
          <div class="news-card__image">
            <img
              v-if="item.coverPath && !imageErrors[item.noticeId]"
              :src="item.coverPath"
              :alt="item.noticeTitle"
              @error="handleImageError(item.noticeId)"
            />
            <span v-else class="news-card__empty">暂无图片</span>
          </div>
          <div class="news-card__body">
            <time class="news-card__date">{{ item.createTime }}</time>
            <h3>{{ item.noticeTitle }}</h3>
            <span class="news-card__action">查看详情</span>
          </div>
        </router-link>
      </div>

      <div v-else class="news-empty">暂无新闻资讯</div>
    </div>
  </section>
</template>

<script>
import { getNoticeList } from '@/api/kms/notice'

export default {
  name: 'minNews',
  data () {
    return {
      dataList: [],
      imageErrors: {},
      loading: true
    }
  },
  mounted () {
    this.getNews()
  },
  methods: {
    getNews () {
      getNoticeList()
        .then(response => {
          this.dataList = (response.data.rows || []).slice(0, 4).map(item => ({
            ...item,
            coverPath: item.coverPath ? process.env.VUE_APP_BASE_API + item.coverPath : ''
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleImageError (noticeId) {
      this.$set(this.imageErrors, noticeId, true)
    }
  }
}
</script>

<style scoped>
.home-news {
  padding: 88px 0 96px;
  background: #f4f8fb;
}

.home-news__container {
  width: min(1200px, calc(100% - 64px));
  margin: 0 auto;
}

.home-news__heading {
  display: flex;
  align-items: end;
  justify-content: space-between;
  margin-bottom: 30px;
}

.home-news__eyebrow {
  margin: 0 0 6px;
  color: #0f9dfc;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0;
}

.home-news__heading h2 {
  margin: 0;
  color: #1d2a35;
  font-size: 32px;
  font-weight: 500;
  line-height: 1.2;
}

.home-news__more {
  display: inline-flex;
  align-items: center;
  min-height: 36px;
  color: #51616d;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.2s ease;
}

.home-news__more::after {
  margin-left: 8px;
  color: #0f9dfc;
  content: '→';
  font-size: 18px;
  line-height: 1;
}

.home-news__more:hover,
.home-news__more:focus {
  color: #0f9dfc;
}

.home-news__more:focus,
.news-card:focus {
  outline: 2px solid #0f9dfc;
  outline-offset: 4px;
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
}

.news-card {
  display: flex;
  min-width: 0;
  min-height: 100%;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e6edf2;
  border-radius: 4px;
  color: inherit;
  text-decoration: none;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}

.news-card:hover {
  border-color: #b9ddf7;
  box-shadow: 0 12px 28px rgba(31, 86, 124, 0.12);
  transform: translateY(-3px);
}

.news-card__image {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #e8eff4;
  aspect-ratio: 16 / 9;
}

.news-card__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
}

.news-card:hover .news-card__image img {
  transform: scale(1.04);
}

.news-card__empty {
  color: #8394a1;
  font-size: 14px;
}

.news-card__body {
  display: flex;
  min-width: 0;
  min-height: 174px;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 22px;
}

.news-card__date {
  margin-bottom: 9px;
  color: #8a9ba8;
  font-size: 13px;
  line-height: 1.3;
}

.news-card h3 {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  color: #273946;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.55;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.news-card__action {
  margin-top: auto;
  padding-top: 16px;
  color: #0f9dfc;
  font-size: 13px;
}

.news-grid--loading {
  grid-auto-rows: auto;
}

.news-skeleton {
  min-height: 0;
  padding: 0 22px 20px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e6edf2;
  border-radius: 4px;
}

.news-skeleton__image,
.news-skeleton__line {
  background: #e8eff4;
}

.news-skeleton__image {
  margin: 0 -22px 20px;
  aspect-ratio: 16 / 9;
}

.news-skeleton__line {
  width: 68%;
  height: 14px;
  margin-top: 12px;
}

.news-skeleton__line--title {
  width: 88%;
  height: 18px;
  margin-top: 0;
}

.news-empty {
  padding: 70px 20px;
  background: #ffffff;
  border: 1px solid #e6edf2;
  color: #8394a1;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 1024px) {
  .news-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 600px) {
  .home-news {
    padding: 58px 0 64px;
  }

  .home-news__container {
    width: min(100% - 32px, 1200px);
  }

  .home-news__heading {
    align-items: center;
    margin-bottom: 22px;
  }

  .home-news__heading h2 {
    font-size: 26px;
  }

  .news-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .news-card__body {
    min-height: 124px;
    padding: 17px 18px;
  }

  .news-skeleton {
    padding: 0 18px 17px;
  }

  .news-skeleton__image {
    margin-right: -18px;
    margin-left: -18px;
  }
}
</style>